
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.625 10.875a2.625 2.625 0 105.25 0 2.625 2.625 0 10-5.25 0zM3.75 18.75a4.5 4.5 0 019 0zm10.5-7.5h4.5m-4.5 3h6","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M21.75 5.25H2.25a1.5 1.5 0 00-1.5 1.5v15a1.5 1.5 0 001.5 1.5h3a1.5 1.5 0 013 0h7.5a1.5 1.5 0 013 0h3a1.5 1.5 0 001.5-1.5v-15a1.5 1.5 0 00-1.5-1.5zm1.5-3a1.5 1.5 0 00-1.5-1.5H2.25a1.5 1.5 0 00-1.5 1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    